import React from 'react';
import { Plus, MessageSquare, Trash2 } from 'lucide-react';

const STROKE = 2.75;

function formatRelative(iso) {
  if (!iso) return '';
  const then = new Date(iso);
  const now = new Date();
  const diff = (now - then) / 1000;
  if (diff < 60) return 'just now';
  if (diff < 3600) return `${Math.floor(diff / 60)}m`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h`;
  return `${Math.floor(diff / 86400)}d`;
}

function ThreadList({ threads, activeId, onSelect, onNew, onDelete, loading }) {
  return (
    <aside className="chat-rail">
      <button type="button" className="btn btn-primary chat-new-btn" onClick={onNew}>
        <Plus size={16} strokeWidth={STROKE} />
        <span>New conversation</span>
      </button>

      <div className="chat-rail-section-label">
        <span className="card-kicker">Recent</span>
        <span className="chat-rail-count">
          {loading ? '…' : threads.length}
        </span>
      </div>

      <div className="chat-rail-list">
        {(!loading && threads.length === 0) ? (
          <div className="chat-rail-empty">No threads yet.</div>
        ) : null}

        {threads.map(t => (
          <div
            key={t.id}
            className={`chat-rail-item${t.id === activeId ? ' is-active' : ''}`}
            onClick={() => onSelect(t.id)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => { if (e.key === 'Enter') onSelect(t.id); }}
          >
            <span className="chat-rail-icon">
              <MessageSquare size={14} strokeWidth={STROKE} />
            </span>
            <span className="chat-rail-text">
              <span className="chat-rail-title">{t.title || 'New conversation'}</span>
              <span className="chat-rail-time">{formatRelative(t.updated_at)}</span>
            </span>
            <button
              type="button"
              className="chat-rail-delete"
              onClick={(e) => {
                e.stopPropagation();
                onDelete(t.id);
              }}
              aria-label="Delete thread"
              title="Delete thread"
            >
              <Trash2 size={13} strokeWidth={STROKE} />
            </button>
          </div>
        ))}
      </div>
    </aside>
  );
}

export default ThreadList;
